import * as Yup from 'yup'
import Statics from 'objects/common/Statics'

export const validationSchema = Yup.object().shape({
    id_tipo_condicion:  Yup.string().required("El tipo de condicion es obligatoria."),
    id_curso_escolar:   Yup.string().required("El curso escolar es obligatorio."),
    condicion:          Yup.number().required("La condición es obligatoria.").transform(Statics.validatorValidNumberWithDecimals).typeError("La condición tiene que ser un numero"),
})